import { render, staticRenderFns } from "./OffersPageHeader.vue?vue&type=template&id=7da80b60&scoped=true&"
import script from "./OffersPageHeader.vue?vue&type=script&lang=js&"
export * from "./OffersPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./OffersPageHeader.vue?vue&type=style&index=0&id=7da80b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da80b60",
  null
  
)

export default component.exports